export default __webpack_public_path__ + "static/media/invalid-name@2x.49046f7c.webp";